import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const CustomsDeclarations = {
  id: 'customs-declarations',
  name: BulkActions.customsDeclarations.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(
        BulkUpdateActions.startBulkUpdateJob(bulkUpdateTypeData, [BulkActions.customsDeclarations], ids, GuidService.newGuid(), filters),
      );
  },
};
